import CalendarSharingDeliveryOption from '../store/schema/CalendarSharingDeliveryOption';
import CalendarSharingError from '../store/schema/CalendarSharingError';
import GetSharingPermissionsResponseMessage from 'owa-service/lib/contract/GetSharingPermissionsResponseMessage';
import getSharingPermissionsService from '../services/getSharingPermissionsService';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';
import { orchestrator } from 'satcheljs';
import { PerformanceDatapoint } from 'owa-analytics/lib/datapoints/PerformanceDatapoint';
import { saveInitialCalendarSharingPermissions } from '../actions/calendarSharing';
import '../store/sharingStore';
import {
    showCalendarSharingPermissionsDialog,
    setInitialSharingPermissionsPending,
    setCalendarSharingInitialLoadError,
} from '../actions/calendarSharing';

export default orchestrator(showCalendarSharingPermissionsDialog, async msg => {
    let folderId = msg.folderId;
    setInitialSharingPermissionsPending(true);
    setCalendarSharingInitialLoadError(false);
    let dataPoint = new PerformanceDatapoint('GetSharingPermissionsForCalendarRequest');
    let data: GetSharingPermissionsResponseMessage = await getSharingPermissionsService(folderId);
    setInitialSharingPermissionsPending(false);
    if (data) {
        dataPoint.end();
        let { peopleInsideOrg, peopleOutsideOrg, delegates } = processSharingPermissionsResponse(
            data
        );
        let currentDeliveryOption: CalendarSharingDeliveryOption = data.CurrentDeliveryOption.valueOf();
        saveInitialCalendarSharingPermissions(
            peopleInsideOrg,
            peopleOutsideOrg,
            delegates,
            currentDeliveryOption
        );
    } else {
        dataPoint.endWithError(DatapointStatus.RequestNotComplete, new Error('Request failed'));
        setCalendarSharingInitialLoadError(true);
    }
});

export let initializeIsPending = function(recipients: SharingPermissionItemState[]) {
    recipients = recipients.map(function(item: SharingPermissionItemState) {
        item.isPending = false;
        item.errorStatus = CalendarSharingError.None;
        return item;
    });
};

let sortSharingPermissionsInfo = function(
    sharingPermissions: SharingPermissionItemState[],
    index: number
) {
    sharingPermissions.splice(
        index,
        sharingPermissions.length,
        ...sharingPermissions
            .slice(index)
            .sort((firstItemDisplayName, secondItemDisplayName) =>
                firstItemDisplayName.EmailAddress.Name.localeCompare(
                    secondItemDisplayName.EmailAddress.Name
                )
            )
    );
};

export let processSharingPermissionsResponse = function(
    data: GetSharingPermissionsResponseMessage
): {
    peopleInsideOrg: SharingPermissionItemState[];
    peopleOutsideOrg: SharingPermissionItemState[];
    delegates: SharingPermissionItemState[];
} {
    let recipients = data.Recipients;
    let peopleInsideOrg: SharingPermissionItemState[] = [];
    let peopleOutsideOrg: SharingPermissionItemState[] = [];
    let delegates: SharingPermissionItemState[] = [];

    peopleInsideOrg =
        recipients &&
        recipients.filter(function(recipient: SharingPermissionItemState) {
            return recipient.IsInsideOrganization && recipient.CurrentDetailLevel != 'Delegate';
        });

    initializeIsPending(peopleInsideOrg);
    peopleInsideOrg.reverse();
    // Sort the items based on the display names starting from index 1,
    // leaving aside the first item, which is 'My Organization'
    sortSharingPermissionsInfo(peopleInsideOrg, 1);

    peopleOutsideOrg =
        recipients &&
        recipients.filter(function(recipient: SharingPermissionItemState) {
            return !recipient.IsInsideOrganization;
        });

    initializeIsPending(peopleOutsideOrg);
    peopleOutsideOrg.reverse();
    sortSharingPermissionsInfo(peopleOutsideOrg, 0);

    delegates =
        recipients &&
        recipients.filter(function(recipient: SharingPermissionItemState) {
            return recipient.IsInsideOrganization && recipient.CurrentDetailLevel == 'Delegate';
        });
    initializeIsPending(delegates);
    delegates.reverse();
    sortSharingPermissionsInfo(delegates, 0);

    return {
        peopleInsideOrg,
        peopleOutsideOrg,
        delegates,
    };
};
